import { HorizontalSpacer, Image, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionErrorPanel extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    imageInInvoiceErr: Image;
    imageInStatusErr: Image;
    imageInTenderErr: Image;
    imageOutInvoiceErr: Image;
    imageOutStatusErr: Image;
    imageOutTenderErr: Image;
    panelErrorImages: Panel;
}
